import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SuccessAlert from "../common/SuccessAlert";
import CategoriesList from "../common/CategoriesList";
import fetchData from "../../api/fetchApi";
import SunEditor from "suneditor-react";
import { UploadCloud, File as FileIcon, X } from 'lucide-react';
const sunEditorOptions = {
  buttonList: [
    ['undo', 'redo'],
    ['bold', 'underline', 'italic', 'strike'],
    ['fontSize', 'formatBlock'],
    ['fontColor', 'hiliteColor'],
    ['align', 'list', 'lineHeight'],
    ['link', 'image', 'video'],
    ['removeFormat'],
  ],
  defaultTag: 'div'
};

export default function AddLawPage() {
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState(false);
  // State for form fields
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [content, setContent] = useState("");
  

  const [documentNo, setDocumentNo] = useState("");
  const  [lawnumber , setLawnumber] = useState("");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [journalNo, setJournalNo] = useState("");
  const [articleNo, setArticleNo] = useState("");
  const [basicLawName, setBasicLawName] = useState("");
  const [lawType, setLawType] = useState("التعديلات القانونية");
  const [categories, setCategories] = useState([]);
  const [categoryUuid, setCategoryUuid] = useState("");
  const [publishedDate, setPublishedDate] = useState("");
  const [effectiveDate, setEffectiveDate] = useState("");

  const [lawNumber, setLawNumber] = useState("");
  const [journalNumber, setJournalNumber] = useState("");

  // Dummy handler for file upload
const [files, setFiles] = useState([]);
const [fileUuids, setFileUuids] = useState([]);
const [uploading, setUploading] = useState(false);
const [uploadError, setUploadError] = useState(null);

  // Stats and totals from new API shape
  const [apiStats, setApiStats] = useState(null);
  const [apiTotal, setApiTotal] = useState(0);
  const [statsLoading, setStatsLoading] = useState(false);

const handleFileChange = async (e) => {
  if (e.target.files && e.target.files.length > 0) {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    setUploading(true);
    setUploadError(null);
    try {
      const formData = new FormData();
      selectedFiles.forEach((file) => formData.append('file', file));
      // Use fetch directly for file upload
      const res = await fetchData('upload', 
       'POST',
        formData,
      );
     
      const uuids = res.uuid;
     
      setFileUuids(uuids);
    } catch (err) {
      setUploadError('فشل رفع الملفات');
      setFileUuids([]);
    } finally {
      setUploading(false);
    }
  }
};


  // Dummy submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      title: title || "",
      reference_number: documentNo || "",
      content: content || "",
      published_date: publishedDate || "",
      effective_date: effectiveDate || "",
      category_uuid: categoryUuid || "",
      file_uuids: [fileUuids],
      law_number: lawNumber || "",
      reference_number: referenceNumber || "",
      journal_number: journalNumber || "",
    };
    try {
      await fetchData('admin/law', 'POST', JSON.stringify(payload));
      setShowAlert(true);
      // Optionally reset form or navigate
      navigate(-1);
    } catch (err) {
      console.error('Failed to create law', err);
      // Could show error toast if needed
    }
  };
  // Fetch categories once
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetchData('admin/law-categories');
        const items = Array.isArray(res) ? res : (res?.items || res?.data || res?.categories || []);
        setCategories(Array.isArray(items) ? items : []);
      } catch (e) {
        console.error('Failed to load categories', e);
        setCategories([]);
      }
    };
    fetchCategories();
  }, []);

  // Fetch laws items + stats for dashboard info (new API shape)
  React.useEffect(() => {
    let mounted = true;
    async function loadStats() {
      setStatsLoading(true);
      try {
        const res = await fetchData('admin/laws'); // assuming endpoint - adjust if different
        if (!mounted) return;
        // API returns { items: [...], stats: {...}, total }
        setApiStats(res?.stats || null);
        setApiTotal(res?.total || 0);
      } catch (err) {
        console.error('Failed to load laws stats', err);
        setApiStats(null);
        setApiTotal(0);
      } finally {
        if (mounted) setStatsLoading(false);
      }
    }
    loadStats();
    return () => { mounted = false; };
  }, []);
  return (
    <div className="min-h-screen bg-white p-6" dir="rtl">
        <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">إضافة قانون جديد</h1>
       
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-gray-500">
          <span>عودة</span>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
        </button>
      </div>
      <div className=" mx-auto">
        <form onSubmit={handleSubmit} className="space-y-6">
            <div className="border border-dashed border-gray-300 rounded-2xl p-6 text-center">
              <label htmlFor="file-upload" className="cursor-pointer flex flex-col items-center justify-center">
                <UploadCloud className="w-10 h-10 text-gray-400 mb-2" />
                <h3 className="text-lg font-semibold text-gray-800">اختر صورة غلاف القانون</h3>
                <p className="text-sm text-gray-500">تنسيقات JPEG و PNG و PDF و MP4، حتى 50 ميجابايت.</p>
              </label>
              <input id="file-upload" type="file" className="hidden"
              accept="image/*,application/pdf,video/*"
               multiple onChange={handleFileChange} />
              {uploading && <div className="mt-2 text-sm text-blue-600">جاري رفع الملفات...</div>}
              {uploadError && <div className="mt-2 text-sm text-red-600">{uploadError}</div>}
              {files.length > 0 && (
                <div className="mt-4 bg-gray-100 border border-gray-200 rounded-lg p-3 flex flex-col gap-2 text-sm">
                  {files.map((file, idx) => (
                    <div key={idx} className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <FileIcon className="w-8 p-8 text-red-500" />
                        <div>
                          <p className="font-semibold text-gray-800">{file.name}</p>
                          <p className="text-gray-500">{(file.size / 1024).toFixed(2)} كيلوبايت</p>
                        </div>
                      </div>
                      <button
                        type="button"
                        onClick={() => setFiles(files.filter((_, i) => i !== idx))}
                        className="text-gray-500 hover:text-red-600"
                      >
                        <X size={20} />
                      </button>
                    </div>
                  ))}
                  {fileUuids.length > 0 && (
                    <div className="text-green-600 text-xs mt-2">تم رفع الملفات بنجاح</div>
                  )}
                </div>
              )}
            </div>
          <input type="text" className="w-full border border-gray-300 rounded-lg p-3" placeholder="عنوان القانون" value={title} onChange={e => setTitle(e.target.value)} />
          {/* <input type="text" className="w-full border border-gray-300 rounded-lg p-3" placeholder="وصف مختصر للقانون" value={desc} onChange={e => setDesc(e.target.value)} />
          */} <div className="bg-white border border-gray-200 rounded-lg p-3">
            <div className="mb-2 text-gray-500">محتوى القانون</div>
             <SunEditor
              setContents={content}
              onChange={setContent}
              setOptions={sunEditorOptions}
              height="300px"
            />
          </div>
          <div className="grid grid-cols-1  gap-4">
         
              <input type="text" className="border border-gray-300 rounded-lg p-3" placeholder="رقم القانون" value={lawNumber} onChange={e => setLawNumber(e.target.value)} />
            
            <input type="text" className="border border-gray-300 rounded-lg p-3" placeholder="رقم المادة" value={articleNo} onChange={e => setArticleNo(e.target.value)} />
         </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <input type="text" className="border border-gray-300 rounded-lg p-3" placeholder="رقم الجريدة" value={journalNumber} onChange={e => setJournalNumber(e.target.value)} />
                <input type="text" className="w-full border  border-gray-300 rounded-lg p-3 text-sm"   placeholder="رقم المرجع" value={referenceNumber} onChange={e => {
                setReferenceNumber(e.target.value)
             


              }} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
            <div>
              <label className="block text-sm text-gray-600 mb-1">تاريخ النشر</label>
              <input type="date" className="w-full border border-gray-300 rounded-lg p-2" value={publishedDate} onChange={e => setPublishedDate(e.target.value)} />
            </div>
            <div>
              <label className="block text-sm text-gray-600 mb-1">تاريخ السريان</label>
              <input type="date" className="w-full border border-gray-300 rounded-lg p-2" value={effectiveDate} onChange={e => setEffectiveDate(e.target.value)} />
            </div>
          </div>
          <CategoriesList
                       value={categoryUuid}
                       onChange={setCategoryUuid}
                       categories={categories}
                     />
          <div className="flex justify-between mt-6">
            <button type="button" className="px-6 py-2 rounded-lg border border-gray-300 bg-white text-gray-700">إلغاء</button>
            <button type="submit" className="px-8 py-3 rounded-lg bg-red-700 text-white font-bold">إضافة القانون</button>
          </div>
        </form>
      </div>
      {showAlert && <SuccessAlert message="تم حفظ القانون في النظام وسيتم نشره في التطبيق متضمنا العنوان والوصف ورقم القانون، ليكون متاحًا للمستخدمين ضمن قاعدة بيانات القوانين." onClose={() => setShowAlert(false)} />}
    </div>
  );
}
